import { ClienteProdutoComercial } from '../../../../../../../types/cliente-produto';
import { formatPreco, simNao } from '../format';
import { CollapsibleSection } from './collapsible-section';
import { Row } from './styles';

interface Props {
  data: ClienteProdutoComercial;
}

export const ComercialSection = ({ data }: Props) => (
  <CollapsibleSection
    title="Comercial e pagamento"
    defaultOpen
    testId="produto-section-comercial"
  >
    <Row>
      <span>Preço</span>
      <span>{formatPreco(data.preco, data.moedaSigla)}</span>
    </Row>
    {data.moedaSigla && (
      <Row>
        <span>Moeda</span>
        <span>{data.moedaSigla}</span>
      </Row>
    )}
    <Row>
      <span>Métodos de pagamento</span>
      <span>
        {data.metodoPagamentoDescricoes.length > 0
          ? data.metodoPagamentoDescricoes.join(', ')
          : '—'}
      </span>
    </Row>
    {data.parcelamentoDescricao && (
      <Row>
        <span>Parcelamento</span>
        <span>{data.parcelamentoDescricao}</span>
      </Row>
    )}
    <Row>
      <span>Recorrência</span>
      <span>{simNao(data.recorrencia)}</span>
    </Row>
    <Row>
      <span>Participa de recorrência</span>
      <span>{simNao(data.participaRecorrencia)}</span>
    </Row>
    {data.garantiaDescricao && (
      <Row>
        <span>Garantia</span>
        <span>{data.garantiaDescricao}</span>
      </Row>
    )}
    {data.tipoDescricao && (
      <Row>
        <span>Tipo</span>
        <span>{data.tipoDescricao}</span>
      </Row>
    )}
    {data.entregaDescricao && (
      <Row>
        <span>Entrega</span>
        <span>{data.entregaDescricao}</span>
      </Row>
    )}
    <Row>
      <span>É kit</span>
      <span>{simNao(data.kit)}</span>
    </Row>
    <Row>
      <span>Compra sem PIX</span>
      <span>{simNao(data.purchaseNoPix)}</span>
    </Row>
    {data.tempoCarrinhoAbandonado && (
      <Row>
        <span>Carrinho abandonado</span>
        <span>
          {data.tempoCarrinhoAbandonado}
          {data.unidadeMedidaCarrinhoAbandonado != null
            ? ` (unidade ${data.unidadeMedidaCarrinhoAbandonado})`
            : ''}
        </span>
      </Row>
    )}
  </CollapsibleSection>
);
